export const AOI_OPTIONS_ROUTES_BY_PROVIDER_CATEGORY = {
  get: '/areas-of-interest/specialties/{providerCategoryId}',
};
